import { ca } from '@cian/analytics';

export const trackEstimationHistoryOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'EstimationHistoryOpen',
  });
};

export const trackEstimationValueInfoOpen = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click_sopr',
    label: 'EstimationValueInfo',
  });
};

export const trackGoToValuationInfo = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'EstateCalculator',
    action: 'Click',
    label: 'GoToValuationInfo',
  });
};
